import React from 'react';

const PageHeader = () => {
  return (
    <>
      {/* Page Title */}
      <h1 className="text-[44px] font-bold text-[#181e25] mb-2">Choose flights</h1>
      
      {/* New Search Link */}
      <div className="mb-6">
        <a href="/" className="text-[#0078d2] text-sm hover:underline">« New search</a>
      </div>
    </>
  );
};

export default PageHeader;
